import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'

import selectCurrentTicketLinkedCards from './selectCurrentTicketLinkedCards'

export default createSelector(selectCurrentTicketLinkedCards, cards => {
  if (!cards) return emptyObj
  return cards.reduce((result, card) => {
    // eslint-disable-next-line no-param-reassign
    result[card.id] = card
    return result
  }, {})
})
